import { Query } from '../models/analytics-api/query.model';
import { QueryResult, Row, Series } from '../models/analytics-api/query_result.model';
import { Dimension, Metric } from '../models/analytics-api/schema.model';

export class Result {
  private _fields = new Map<string, Dimension | Metric>()

  static parse(qr: QueryResult) {
    return new Result(qr.query, qr.timestamps, qr.dimensions, qr.metrics, qr.rows, qr.series)
  }

  constructor(
    public readonly query: Query,
    public readonly timestamps: number[],
    public readonly dimensions: Dimension[],
    public readonly metrics: Metric[],
    public readonly rows: Row[],
    public readonly series: Series[]
  ) {
    for (const dimension of dimensions) {
      this._fields.set(dimension.name, dimension)
    }

    for (const metric of metrics) {
      this._fields.set(metric.name, metric)
    }
  }

  getField(name) {
    return this._fields.get(name)
  }
}
